'use strict';
import React from 'react';
import ReactDOM from 'react-dom';
import Batman from '@alife/nano-batman';
import Arms from '@alife/zoro-arms';
import Notice from './login/js/notice.js';

import './login.scss';

Notice();
// 从url中获取参数
function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) return pair[1];
    }
    return null;
}

function getRenturnUrl() {
    var returnUrl = getQueryVariable('return_url') || getQueryVariable('return');
    var referrer = document.referrer;
    var rootUrl = '/';
    if (returnUrl) {
        returnUrl = decodeURIComponent(returnUrl);
    } else {
        returnUrl = referrer || rootUrl;
    }
    return returnUrl;
} 

const startRunTime = Date.now();

const tab = window.ae_page_config.selectedType == 'sign' ? 'login' : 'join';

const joinParams = {
    registerFrom: 'AE_MAIN_REGISTER',
    isSendCoupon: true
};

const loginParams = {
    loginFrom: 'AE_MAIN_LOGIN'
};

const pcReturnUrl = getRenturnUrl();

const always = function () {
    window.xman_callback && window.xman_callback();
};



const afterLoginInit = function(arg) {
    if (tab == 'login') {
        Arms.report({
            cfpt: Promise.resolve(arg && arg.cfptPage),
            t2: Promise.resolve(startRunTime),
            t3: Promise.resolve(arg && arg.iframeStartTime)
        });
    }
}

const  afterJoinInit = function() {
    if (tab == 'join') {
        Arms.report({
            cfpt: Promise.resolve(Date.now()),
            t2: Promise.resolve(startRunTime)
        });
    }
}


ReactDOM.render(
    <Batman tab={tab} joinParams={joinParams}  snsReturnUrl = {pcReturnUrl} loginParams={loginParams} always={always} afterLoginInit={afterLoginInit} afterJoinInit={afterJoinInit} />,
    document.getElementById('expressbuyerlogin'),
);

if (module.hot) {
    module.hot.accept();
}

if (process.env.NODE_ENV !== 'production') {
    if (new URLSearchParams(window.location.search).has('profiler')) {
        const { whyDidYouUpdate } = require('why-did-you-update');
        whyDidYouUpdate(React);
    }
}

